import React from 'react';
import { 
  X, 
  TrendingUp, 
  DollarSign, 
  Clock, 
  CheckCircle2,
  Info,
  ArrowRight
} from 'lucide-react';
import './styles.scss';

const StatDetailModal = ({ isOpen, onClose, stat, institutionName }) => {
  if (!isOpen || !stat) return null;

  const getIcon = (id) => {
    switch (id) {
      case 'salary': return <TrendingUp size={28} />;
      case 'savings': return <DollarSign size={28} />;
      case 'time': return <Clock size={28} />;
      case 'efficiency': return <CheckCircle2 size={28} />;
      default: return <Info size={28} />;
    }
  };

  return (
    <div className="modal-overlay-glass" onClick={onClose}>
      <div 
        className="stat-detail-modal-premium animate-scale-in" 
        onClick={(e) => e.stopPropagation()}
      >
        <header className="modal-header">
          <div className="header-content">
            <div className="icon-badge">
              {getIcon(stat.id)}
            </div>
            <div className="title-stack">
              <span className="stat-category-pill">
                {stat.subtext}
              </span>
              <h2>{stat.label}</h2>
            </div>
          </div>
          <button className="close-btn-round" onClick={onClose} aria-label="Close modal">
            <span style={{ fontSize: '32px', lineHeight: 0.8, fontWeight: '300', color: '#64748b' }}>&times;</span>
          </button>
        </header>

        <div className="modal-body-scrollable">
          <div className="value-highlight-section">
            <div className="main-value-display">
              <span className="value">{stat.value}</span>
              <span className="label">Institutional Metric for {institutionName}</span>
            </div>
          </div>

          <section className="explanation-section">
            <div className="section-header">
              <Info size={18} />
              <h3>Detailed Breakdown</h3>
            </div>
            <div className="explanation-content">
              {stat.longExplanation.split('\n').map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </section>

          <section className="key-takeaways">
            <h3>Key Insights</h3>
            <div className="takeaways-grid">
              {stat.takeaways.map((takeaway, i) => (
                <div key={i} className="takeaway-item">
                  <ArrowRight size={16} className="takeaway-icon" />
                  <span>{takeaway}</span>
                </div>
              ))}
            </div>
          </section>
        </div>

        <footer className="modal-footer">
          <div className="footer-info">
            <p className="data-source-tag">Verified by Linqra Academic Intelligence Engine</p>
          </div>
          <button className="btn-close-modal" onClick={onClose}>
            Close Analysis
          </button>
        </footer>
      </div>
    </div>
  );
};

export default StatDetailModal;
